import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

import Cursor from "./components/Cursor";
import PageLoader from "./components/PageLoader";
import PublicLayout from "./components/PublicLayout";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Messages from "./pages/admin/Messages";
import BlogManager from "./pages/admin/BlogManager";
import PortfolioManager from "./pages/admin/PortfolioManager";
import ServicesManager from "./pages/admin/ServicesManager";
import TeamManager from "./pages/admin/TeamManager";
import Settings from "./pages/admin/Settings";

const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--rich-black)", color: "var(--warm-off-white)" }}>…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <PageLoader />
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Cursor />
            <Toaster theme="dark" position="bottom-right" richColors />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/hizmetler" element={<Services />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/projeler" element={<Portfolio />} />
                <Route path="/about" element={<About />} />
                <Route path="/hakkimizda" element={<About />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/fiyatlar" element={<Pricing />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/iletisim" element={<Contact />} />
              </Route>

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
                <Route index element={<Dashboard />} />
                <Route path="messages" element={<Messages />} />
                <Route path="blog" element={<BlogManager />} />
                <Route path="portfolio" element={<PortfolioManager />} />
                <Route path="services" element={<ServicesManager />} />
                <Route path="team" element={<TeamManager />} />
                <Route path="settings" element={<Settings />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
